import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {IpopConfigurationRouteService} from './ipop-configuration-route.service';

@Injectable({
  providedIn: 'root'
})
export class IpopConfigurationRouteDispatcherGuard
{
  constructor(private ipopConfigurationRouteService: IpopConfigurationRouteService)
  {
  }

  /** Redirects the stable dispatcher to one concrete IPOP route. */
  canActivate(route: ActivatedRouteSnapshot): Observable<UrlTree>
  {
    const routeDecision = this.ipopConfigurationRouteService.resolveDispatcherRoute(route);

    return routeDecision;
  }
}
